export default "__VITE_ASSET__6414e28e__"